import { useEffect, useState } from "react";
import useAlertStore from "store/zustand/alert";
import { Alert, Box, Snackbar } from "@mui/material";
import useLocalizationStore from "store/zustand/localization";

const AlertNotification = () => {
  const { language } = useLocalizationStore();

  const {
    createAlert,
    type,
    status,
    notification = { title: "", body: "", titleArabic: "", bodyArabic: "" },
  } = useAlertStore();
  const [showAlert, setShowAlert] = useState(false);
  const [alertsType, setAlertsType] = useState();

  useEffect(() => {
    setShowAlert(status);
    setAlertsType(type);
  }, [type, status]);

  const closeHandler = () => {
    createAlert({
      type: "",
      message: "",
      title: "",
      status: false,
      notification: {},
    });
  };
  return (
    <>
      {showAlert && (
        <Snackbar
          open={showAlert}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          autoHideDuration={3000}
          onClose={closeHandler}
          sx={{ zIndex: "999999" }}
        >
          <Alert
            onClose={closeHandler}
            severity={alertsType}
            sx={{
              width: "100%",
              textTransform: "capitalize",
              px: 1,
              borderRadius: "4px",
            }}
          >
            {language !== "ar" ? (
              <>
                <strong>{notification?.title}</strong>
                <div>{notification?.body}</div>
              </>
            ) : (
              <Box sx={{ mx: 2 }}>
                <strong>{notification?.titleArabic}</strong>
                <div>{notification?.bodyArabic}</div>
              </Box>
            )}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default AlertNotification;
